const closeNavBarEvent = new Event("closeNavBar");

export default closeNavBarEvent;
